import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import TypeService from '@iso/services/SettingsService/WarehouseService/TypeService';

function* watchFetchWarehouseTypes() {
    yield takeEvery(
        types.REQUEST_FETCH_WAREHOUSE_TYPES,
        pagination('warehouseTypes').saga(TypeService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchWarehouseTypes),
    ]);
}

export default paginationSaga;